import { SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';
import { AppModules } from '~/services/Permissions';

import { useModulesConfig } from '../company';

import { CustomFieldValues } from './types';

export const SWR_KEY_CUSTOM_EMPLOYEE_DATA = 'getCustomEmployeeFields';

export const getCustomEmployeeFields = (
  id: string,
): Promise<CustomFieldValues> => {
  return fetchFromOldApi(`/json/customdata/EMPLOYEE/${id}`).then((r) =>
    r.json(),
  );
};

export const useCustomEmployeeData = (
  employeeId: number,
  swrConfig?: SWRConfiguration,
  isDisabled?: boolean,
): UseSWROutput<CustomFieldValues> => {
  const { isModuleEnabled } = useModulesConfig();
  const isCustomDataEnabled = isModuleEnabled(AppModules.CUSTOM_DATA);

  return useSWR<CustomFieldValues>(
    !!employeeId && !isDisabled && isCustomDataEnabled
      ? [SWR_KEY_CUSTOM_EMPLOYEE_DATA, employeeId]
      : null,
    () => getCustomEmployeeFields(String(employeeId)),
    swrConfig,
  );
};
